(function() {
    'use strict';

    angular
        .module('home')
        .component('home', {
            bindings: { },
            templateUrl: '/home/views/home.html',
            controller: [
                Home
            ],
        });
    
    function Home(
        
    ) {
        var vm = this;

        vm.$onInit = function () {

        };
    }
})();